import { Injectable, inject } from '@angular/core';
import type { RegisterOutcome, SyncResult, UploadResult } from '../entities/upload.models';
import type { EnsureProjectInfo, GalleryUploadDataPort, RegisterPhotoInput, UploadOpts } from './gallery-upload.data';
import { GalleryUploadApiService } from './gallery-upload-api.service';

@Injectable({ providedIn: 'root' })
export class HttpGalleryUploadData implements GalleryUploadDataPort {
  private readonly api = inject(GalleryUploadApiService);

  ensureProject(galleryId: string): Promise<EnsureProjectInfo | null> {
    return this.api.ensureProject(galleryId);
  }

  upload(projectId: string, file: File, fileId: string, opts?: UploadOpts): Promise<UploadResult> {
    return this.api.upload(projectId, file, fileId, opts);
  }

  register(galleryId: string, photos: RegisterPhotoInput[]): Promise<RegisterOutcome[] | null> {
    return this.api.register(galleryId, photos);
  }

  syncStatus(galleryId: string): Promise<SyncResult | null> {
    return this.api.syncStatus(galleryId);
  }

  cancelUploads(projectId: string): void {
    this.api.cancelUploads(projectId);
  }
}
